exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CodeMirror {\r\n    flex: 1;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/components/Playground/_editor.css
// module id = 947
// module chunks = 0